import React, { useState } from 'react';

type ChildrenParams = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
};

export type PopoverControllerProps = {
  children: (params: ChildrenParams) => React.ReactNode;
};

const PopoverController = ({ children }: PopoverControllerProps) => {
  const [visible, setVisible] = useState(false);

  return <>{children({ visible, setVisible })}</>;
};

export default PopoverController;
